import { createIntl, createIntlCache } from 'react-intl'
import enMessages from '../../../_metronic/i18n/messages/en.json'
import jaMessages from '../../../_metronic/i18n/messages/ja.json'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

const allMessages: {[key: string]: {[key: string]: string}} = {
  en: enMessages,
  ja: jaMessages,
}

const cache = createIntlCache()

// Get current language from localStorage (same logic as in Metronici18n.tsx)
const getCurrentLanguage = (): 'en' | 'ja' => {
  
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      const config = JSON.parse(ls)
      return config.selectedLang || 'ja'
    } catch (er) {
      console.error(er)
    }
  }
  return 'ja' // Default fallback
}

// Create intl instance with current language
export const getCurrentIntl = () => {
  const locale = getCurrentLanguage()
  return createIntl({locale, messages: allMessages[locale]}, cache)
}
